import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
export default {
  breadcrumbsContainer: {
    width: '100%',
    zIndex: theme.zIndex.breadcrumbs,
    display: 'flex',
    flexFlow: 'row nowrap',
    whiteSpace: 'nowrap',
    position: 'relative'
  },
  breadcrumbContainer: {
    position: 'relative',
    overflowX: 'auto',
    p: ['12px 16px', '12px 16px', '12px 24px', '12px 40px'],
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  },
  breadcrumb: {
    display: 'inline-flex',
    fontSize: 'caption',
    fontFamily: 'uniform',
    position: 'relative'
  },
  divider: {
    m: '0 calc(1rem * 0.75)',
    color: theme.rawColors.darkGrey600
  },
  breadcrumbLink: (activeDropdown: boolean, isLast: boolean) => ({
    cursor: 'pointer',
    color: `${isLast ? theme.rawColors.darkGrey700 : activeDropdown ? theme.rawColors.darkGrey700 : theme.rawColors.darkGrey600} !important`,
    position: 'relative',
    textDecoration: 'none',
    height: '24px',
    minHeight: '24px',
    lineHeight: '24px',
    display: ['none', 'none', 'none', 'flex'],
    alignItems: 'center',
    '&:focus-visible': {
      outline: `2px solid ${theme.rawColors.darkGrey700}`,
      outlineOffset: '2px',
      borderRadius: '2px'
    }
  }),
  breadcrumbLinkMobile: (activeDropdown: boolean, isLast: boolean) => ({
    color: `${isLast ? theme.rawColors.darkGrey700 : activeDropdown ? theme.rawColors.darkGrey700 : theme.rawColors.darkGrey600} !important`,
    display: ['flex', 'flex', 'flex', 'none'],
    alignItems: 'center',
    outline: 'none',
    border: 'none',
    background: theme.rawColors.neutralWhite,
    height: '24px',
    minHeight: '24px',
    lineHeight: '24px',
    WebkitTapHighlightColor: 'transparent',
    WebkitTouchCallout: 'none',
    WebkitUserSelect: 'none',
    userSelect: 'none',
    '&:focus-visible': {
      outline: `2px solid ${theme.rawColors.darkGrey700}`,
      outlineOffset: '2px',
      borderRadius: '2px'
    }
  }),
  breadcrumbInactive: (activeDropdown: boolean, isLast: boolean) => ({
    color: `${isLast ? theme.rawColors.darkGrey700 : activeDropdown ? theme.rawColors.darkGrey700 : theme.rawColors.darkGrey600} !important`,
    height: '24px',
    minHeight: '24px',
    lineHeight: '24px',
    display: 'flex',
    alignItems: 'center'
  }),
  breadcrumbDropdown: (isVisible: boolean) => ({
    position: 'absolute',
    top: 'calc(100% - 14px)',
    left: '20px',
    zIndex: theme.zIndex.breadcrumbs + 1,
    backgroundColor: theme.rawColors.neutralWhite,
    border: `1px solid ${theme.rawColors.lightGrey300}`,
    display: 'inline-flex',
    flexDirection: 'column',
    justifyContent: 'start',
    alignItems: 'center',
    minWidth: '150px',
    maxHeight: '504px',
    overflowY: 'auto',
    opacity: 0,
    transform: 'translateY(-10px)',
    transition: 'opacity 0.3s ease, transform 0.2s ease, left 0.1s ease',
    visibility: 'hidden',
    pointerEvents: 'none',
    ...reusables.scrollbar(),
    ...(isVisible && {
      opacity: 1,
      transform: 'translateY(0)',
      visibility: 'visible',
      pointerEvents: 'auto'
    })
  }),
  dropdownItem: {
    padding: '8px',
    width: '100%',
    textAlign: 'left',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '10px',
    color: `${theme.rawColors.darkGrey700} !important`,
    fontSize: 'caption',
    '&:hover': {
      backgroundColor: theme.rawColors.lightGrey300,
      a: {
        color: `${theme.rawColors.darkGrey700} !important`
      }
    },
    '&:focus-visible': {
      outline: `2px solid ${theme.rawColors.darkGrey700}`,
      outlineOffset: '-2px',
      backgroundColor: theme.rawColors.lightGrey300
    }
  },
  dropdownItemLink: {
    transition: 'none !important',
    color: `${theme.rawColors.darkGrey700} !important`,
    '&:focus-visible': {
      outline: `2px solid ${theme.rawColors.darkGrey700}`,
      outlineOffset: '2px',
      borderRadius: '2px'
    }
  },
  breadcrumbContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    height: '24px',
    minHeight: '24px'
  },
  chevronContainer: {
    display: ['flex', 'flex', 'flex', 'none', 'none'],
    height: '24px',
    width: '24px',
    outline: 'none',
    border: 'none',
    background: theme.rawColors.neutralWhite,
    WebkitTapHighlightColor: 'transparent',
    WebkitTouchCallout: 'none',
    WebkitUserSelect: 'none',
    userSelect: 'none',
    '&:focus-visible': {
      outline: `2px solid ${theme.rawColors.darkGrey700}`,
      outlineOffset: '2px',
      borderRadius: '2px'
    }
  },
  chevronIcon: {
    rotate: '-90deg'
  },
  dropdownItemActive: {
    padding: '8px',
    width: '100%',
    textAlign: 'left',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '10px',
    backgroundColor: theme.rawColors.lightGrey300,
    color: `${theme.rawColors.darkGrey700} !important`,
    cursor: 'default',
    fontSize: 'caption',
    '&:focus-visible': {
      outline: `2px solid ${theme.rawColors.darkGrey700}`,
      outlineOffset: '-2px'
    }
  }
};